import { LegendItem, Polygon, Raster } from "helpers/models";

const getColor = (label: string, legend: LegendItem): string => {
  if (label === "No Data") {
    return "#CCC";
  }
  const rules = legend.rules;
  if (!rules || !rules.length) {
    return "#CCC";
  }
  const rule = rules.find((e) => label === e.title);
  if (!rule || !rule.symbolizers) {
    return "#CCC";
  }
  const raster = (rule.symbolizers[0] as Raster)?.raster?.color;
  const polygon = (rule.symbolizers[0] as Polygon)?.polygon?.fill;
  const color = raster || polygon;
  if (!color) {
    return "#CCC";
  }
  // const opacity = (rule.symbolizers[0] as Raster)?.raster?.opacity;
  return color;
};

export default getColor;
